import { render, staticRenderFns } from "./myselfproduct.vue?vue&type=template&id=761f248e&scoped=true&"
import script from "./myselfproduct.vue?vue&type=script&lang=js&"
export * from "./myselfproduct.vue?vue&type=script&lang=js&"
import style0 from "./myselfproduct.vue?vue&type=style&index=0&id=761f248e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761f248e",
  null
  
)

export default component.exports